import axios from "axios";

// In production on shared hosting, empty string means same-origin ("/api").
// In local development, defaults to backend port 8001.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL !== undefined
  ? process.env.REACT_APP_BACKEND_URL
  : (process.env.NODE_ENV === "production" ? "" : "http://localhost:8001");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("queen_token") || localStorage.getItem("fyn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const PLACEHOLDER_IMG = "/assets/brand/products.jpg";

export function mediaUrl(path) {
  if (!path) return PLACEHOLDER_IMG;
  if (path.startsWith("http")) return path;
  if (path.startsWith("/assets/brand/")) return path;
  return `${BACKEND_URL}${path}`;
}

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
